function FarmnetHttpError(rejection) {
  this.name = 'farmnetHttpError';
  this.message = 'Server error! Status: ' + rejection.status;
  this.rejection = rejection;
}
FarmnetHttpError.prototype = new Error();

global.FarmnetHttpError = FarmnetHttpError;
